import React from 'react';

// App-wide safety net. A render error anywhere below this (e.g. a bad Stripe option)
// would otherwise unmount the whole tree and leave a blank black screen. Instead we
// catch it and show a friendly recovery card so the guest can retry.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Surface in the console for debugging; could be wired to a logger later.
    console.error('Render error caught by ErrorBoundary:', error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={s.page}>
        <div style={s.icon}>😕</div>
        <h1 style={s.title}>Something went wrong</h1>
        <p style={s.sub}>We hit a snag loading this page. Your cart is safe — just reload to continue.</p>
        <button style={s.btn} onClick={() => window.location.reload()}>Reload</button>
      </div>
    );
  }
}

const s = {
  page: { minHeight: '100vh', background: '#080808', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '14px', padding: '24px', textAlign: 'center', fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif' },
  icon: { fontSize: '44px' },
  title: { fontSize: '22px', fontWeight: '700', color: '#fff', margin: 0 },
  sub: { fontSize: '14px', color: '#777', margin: '0 0 8px', lineHeight: 1.5, maxWidth: '300px' },
  btn: { background: '#fff', color: '#000', border: 'none', borderRadius: '14px', padding: '14px 36px', fontSize: '16px', fontWeight: '700', cursor: 'pointer', fontFamily: 'inherit' },
};
